import React from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { message } from 'antd'
import { parseUrl } from './parseUrl'
import { useTranslation } from 'react-i18next'

export const menuList = (data: any, url: string, boorList?: any) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const idMenu: string | number = parseUrl('?', 'type')

  if (data.length === 0) {
    return ''
  }

  if (!idMenu) {
    navigate('/')
    message.error('Ошибка URL адреса')
    return ''
  }
  const arr = data.map(({ id, title, category }: { id: number | string; title: string; category: { id: number; name: string } }) => {
    const slideMenuIdList = [7,8,9,10,18]; // for show route title in nav panel
    const nameCategory = slideMenuIdList.includes(category.id) ? category.name : null;
    return {
      key: id,
      label: <NavLink state={{ breadcrumbs: nameCategory }} to={`/${url}/${id}?type=${idMenu}`}>{title}</NavLink>,
    }
  })

  if (boorList && boorList.length > 0) {
    return [
      {
        key: 0,
        label: t('m16'),
        children: [
          {
            key: `RB`,
            label: <NavLink state={{ breadcrumbs: t('m13')}} to={`/${url}/RB?type=${idMenu}`}>{t('h13')}</NavLink>,
          },
          ...boorList,
        ],
      },
      ...arr,
    ]
  } else {
    return arr
  }
}
